/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {ReactNode} from 'react';
import {StandardTextFieldProps} from '@material-ui/core/TextField';
import {GenericObject} from '@ion/core/src/types/entities';
import {DLSTheme} from '@ion/dls/src/types/types';
import {withDLSTheme} from '../../theme/withDLSTheme';
import CurrentTextField from './current/TextField';
import LegacyTextField from './legacy/TextField';

export interface TextFieldTypes {
  onMount?: Function;
  label?: string | ReactNode;
  hasError?: boolean;
  errorText?: string | ReactNode;
  fieldLabel?: string | ReactNode;
  required?: boolean;
  placeholder?: string | ReactNode;
  inputProps?: GenericObject;
  defaultValue?: string | number | unknown;
  autoComplete?: 'on' | 'off' | 'username';
  styleOverrides?: (theme: DLSTheme) => GenericObject;
  style?: object;
  readOnlyText?: boolean;
  maxLength?: number;
}

export type Props = TextFieldTypes & StandardTextFieldProps;

// Ensures theme-based resolution when importing:
// `import TextField from '@ion/dls/src/components/textfield/TextField';`
export const TextField = withDLSTheme(LegacyTextField, CurrentTextField);

export default TextField;
